var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Requester, { RequestMethod } from '../networking/Requester';
var AudioLoaderRequestFiler = /** @class */ (function () {
    function AudioLoaderRequestFiler() {
    }
    AudioLoaderRequestFiler.prototype.filter = function (request, next) {
        request.responseType = 'arraybuffer';
        return next(request);
    };
    return AudioLoaderRequestFiler;
}());
var AudioLoader = /** @class */ (function () {
    function AudioLoader() {
        this.requester = new Requester('', [AudioLoaderRequestFiler]);
    }
    AudioLoader.getAudioContext = function () {
        if (!this.audioContext) {
            this.audioContext = new AudioContext();
        }
        return this.audioContext;
    };
    AudioLoader.decodeBuffer = function (buffer) {
        return AudioLoader.getAudioContext().decodeAudioData(buffer);
    };
    AudioLoader.prototype.loadAudioBuffer = function (filePath) {
        return __awaiter(this, void 0, void 0, function () {
            var arrayBuffer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requester.request(filePath, RequestMethod.GET)];
                    case 1:
                        arrayBuffer = _a.sent();
                        return [4 /*yield*/, AudioLoader.decodeBuffer(arrayBuffer)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AudioLoader.prototype.generateAudioBarData = function (audioBuffer, chunks) {
        if (chunks === void 0) { chunks = 70; }
        return __awaiter(this, void 0, void 0, function () {
            var data, blockSize, barData, i, blockStart, sum, j, normalizeData;
            return __generator(this, function (_a) {
                data = audioBuffer.getChannelData(0);
                blockSize = Math.floor(data.length / chunks);
                barData = [];
                for (i = 0; i < chunks; i++) {
                    blockStart = blockSize * i;
                    sum = 0;
                    for (j = 0; j < blockSize; j++) {
                        sum += Math.abs(data[blockStart + j]);
                    }
                    barData.push(sum / blockSize);
                }
                normalizeData = function (data) {
                    var multiplier = Math.pow(Math.max.apply(Math, data), -1);
                    return data.map(function (n) { return n * multiplier; });
                };
                return [2 /*return*/, normalizeData(barData)];
            });
        });
    };
    AudioLoader.prototype.generateAudioBarDataFromUrl = function (filePath, chunks) {
        if (chunks === void 0) { chunks = 70; }
        return __awaiter(this, void 0, void 0, function () {
            var audioBuffer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadAudioBuffer(filePath)];
                    case 1:
                        audioBuffer = _a.sent();
                        return [2 /*return*/, this.generateAudioBarData(audioBuffer, chunks)];
                }
            });
        });
    };
    AudioLoader.prototype.generateAudioBarDataFromArrayBuffer = function (buffer, chunks) {
        if (chunks === void 0) { chunks = 70; }
        return __awaiter(this, void 0, void 0, function () {
            var audioBuffer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, AudioLoader.decodeBuffer(buffer)];
                    case 1:
                        audioBuffer = _a.sent();
                        return [2 /*return*/, this.generateAudioBarData(audioBuffer, chunks)];
                }
            });
        });
    };
    return AudioLoader;
}());
export { AudioLoader };
export var getFileDuration = function (file) {
    return new Promise(function (resolve) {
        var path = typeof file === 'string' ? file : URL.createObjectURL(file);
        var audio = new Audio(path);
        audio.addEventListener('loadedmetadata', function () {
            resolve(Math.round(audio.duration));
        });
    });
};
export default AudioLoader;
